let deferredPrompt = null
const listeners = new Set()

const notify = () => listeners.forEach((fn) => fn(!!deferredPrompt))

export const setDeferredPrompt = (event) => {
  deferredPrompt = event
  notify()
}

export const clearDeferredPrompt = () => {
  deferredPrompt = null
  notify()
}

export const triggerInstall = async () => {
  if (!deferredPrompt) return false
  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  clearDeferredPrompt()
  return outcome === 'accepted'
}

export const subscribe = (fn) => {
  listeners.add(fn)
  fn(!!deferredPrompt)
  return () => listeners.delete(fn)
}
